import { useState, useEffect } from "react";
import cogoToast from "cogo-toast";


import { Helmet } from "react-helmet";
import Header from "../components/header/header";
import SidebarOperacion from "../components/header/sidebarOperacion";
import CommonAreaTable from "../components/commonAreas/commonTable";
import Controls from "../components/controls/controls";
import DinamicModal from "../components/dinamicModal/dinamicModal";
import Paginador from "../components/paginador/paginador";
import Request from "../core/httpClient";
import Permissions from "../middlewares/Permissions";

import sortableData from '../helpers/sortableDataTable';
import { useCallback } from "react";
import CommonAreasCreate from "../components/commonAreas/CommonAreasCreate";
import BloqcatModal from "../components/commonAreas/BloqcatModal";

const request = new Request();
const CommonAreas = ({ context }) => {
	const [showModal, setShowModal] = useState(false);
	const [commonAreas, setCommonAreas] = useState([]);
	const [categories, setCategories] = useState([]);
	const [categoria, setCategoria] = useState(0);
	const [filterData, setFilterData] = useState([]);
	const [page, setPage] = useState(1);
	const [filter, setFilter] = useState("");
	const [subfraccionamiento, setSubfraccionamiento] = useState(localStorage.getItem("subfrac") || 0);
	const [subfraccionamientos, setSubfraccionamientos] = useState([]);
	const [imageArea, setImageArea] = useState("");
	const [idSubfrac, setIdSubfrac] = useState([]);
	// Variable separada para los checkboxes; idSubfrac se mantiene intacto.
	const [subfraccionamientosSeleccionados, setSubfraccionamientosSeleccionados] = useState([]);
	const [escritura, setEscritura] = useState(false);
	const [lectura, setLectura] = useState(false);
	const [menu, setMenu] = useState(null);
	const [anuales, setAnuales] = useState(0);
	const [mensuales, setMensuales] = useState(0);
	const [diarias, setDiarias] = useState(0);
	const [consecutivas, setConsecutivas] = useState(0);
	const [pageLength, setPageLength] = useState(20);
	const [direction, setDirection] = useState({});
	const [filterColumn, setFilterColumn] = useState({});
	const [aforoMax, setAforoMax] = useState(false);
	const [name, setName] = useState("");
	const [diasPrevios, setDiasPrevios] = useState(0);
	const [minutosPrevios, setMinutosPrevios] = useState(0);
	const [isDiasDisponible, setIsDiasDisponible] = useState(true);
	const [tiempoDisponible, setTiempoDisponible] = useState(0);
	const [deposito, setDeposito] = useState(0);
	const [descripcion, setDescripcion] = useState("");
	const [motivo, setMotivo] = useState("");
	const [pausar, setPausar] = useState(false);
	const [submenu, setSubmenu] = useState("");
	const [maXVivienda, setMaXVivienda] = useState(1);
	const [subLabel, setSubLabel] = useState("");
	const [aforo, setAforo] = useState(1);
	const [loadingSave, setLoadingSave] = useState(false);
	const [activo, setActivo] = useState(false);
	const [showUpdateCategoryModal, setShowUpdateCategoryModal] = useState(false);

	const state = {
		nombre: name,
		descripcion,
		activo,
		categoria,
		diasPrevios,
		minutosPrevios,
		fianza: deposito,
		tiempoDisponible,
		isDiasDisponible,
		imagenArea: imageArea,
		// idSubfrac se mantiene INTACTO, no lo tocan los checkboxes.
		idSubfrac,
		// subfraccionamientosSeleccionados es lo que controlan los checkboxes.
		subfraccionamientosSeleccionados: Array.isArray(subfraccionamientosSeleccionados)
			? subfraccionamientosSeleccionados.map(id => id.toString())
			: subfraccionamientosSeleccionados
				? [subfraccionamientosSeleccionados.toString()]
				: [],
		subfraccionamientos,
		categories,
		anuales,
		mensuales,
		diarias,
		consecutivas,
		aforo,
		aforoMax,
		maXVivienda,
		pausar,
		motivo,
		subLabel,

	};




	const getCommonAreas = useCallback(async () => {
		try {
			setLoading(true);

			const idSub = subfraccionamiento;

			const data = {
				IdFraccionamiento: parseInt(localStorage.getItem("frac")),
				idSub: idSub,
			};

			const response = await request.post("/commonArea/get/areas", data);

			if (response.commonAreas) {
				const parsedAreas = response.commonAreas.map((row) => {
					if (row.bloqueos !== null) {
						row.bloqueos = JSON.parse(row.bloqueos);
					}
					return row;
				});

				setCommonAreas(parsedAreas);
			} else {
				setMessage("");
			}

			setLoading(false);
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	}, [subfraccionamiento]); // dependencias internas


	// componentDidMount 
	useEffect(() => {
		const init = async () => {
			await validarPermisos();
			await getSubmenu();
			await getCommonAreas();
			await getCategories();
			await getSubFraccionamientos();
		};
		init();
	}, []);

	// componentDidUpdate equivalente para subfraccionamiento
	useEffect(() => {
		getCommonAreas();
	}, [getCommonAreas]);


	const validarPermisos = async () => {
		let permisos = new Permissions();
		let permisosInfo = await permisos.getResult();
		setEscritura(permisosInfo.escritura);
		setLectura(permisosInfo.lectura);
	};

	const getSubmenu = async () => {
		// Verifica que context exista y tenga la función
		if (context && typeof context.getSubmenuOpeName === "function") {
			const submenuRes = await context.getSubmenuOpeName();
			if (submenuRes) {
				setSubmenu(submenuRes);
			}
		}

		const subLabelRes = window.localStorage.getItem("subLabel");
		if (subLabelRes) {
			setSubLabel(subLabelRes);
		}
	};

	const handleOpenCategoryModal = () => {
		setShowUpdateCategoryModal(true);
	};

	const handleCloseModal = () => {
		setShowUpdateCategoryModal(false);
	};

	const handleUpdateCategorySuccess = () => {
		getCommonAreas();
	};

	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");




	const getCategories = async () => {
		try {
			const data = { id: localStorage.getItem("frac") };
			const response = await request.post("/commonArea/get/categories", data);
			if (response && !response.error && response.categories && !response.empty) {
				setCategories(response.categories);
				if (response.categories.length !== 0) {
					setCategoria(response.categories[0].id_categoria);
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getSubFraccionamientos = async () => {
		try {
			const fraccionamiento = localStorage.getItem("frac");
			if (!fraccionamiento) return;
			const data = { idFraccionamiento: fraccionamiento, filter: 1 };
			const response = await request.get("/commonArea/subfraccionamiento/get", data);
			if (response && !response.error && response.subfraccionamientos && !response.empty) {
				setSubfraccionamientos(response.subfraccionamientos);
				setFilterData(response.subfraccionamientos);
			} else {
				setSubfraccionamientos([]);
			}
		} catch (error) {
			console.log(error);
		}
	};


	const openModal = () => {
		// reset de estados
		setMessage(null);
		setImageArea("");
		setName("");
		setDiasPrevios(0);
		setMinutosPrevios(0);
		setIsDiasDisponible(true);
		setTiempoDisponible(0);
		setDeposito(0);
		setDescripcion("");
		setAforo(1);
		setAnuales(0);
		setMensuales(0);
		setDiarias(0);
		setConsecutivas(0);
		setMotivo("");
		setPausar(false);
		setMaXVivienda(1);
		setAforoMax(false);
		setActivo(false);
		// reset de la selección de checkboxes al abrir el modal de creación.
		setSubfraccionamientosSeleccionados([]);

		// abrir modal por id
		const modal = document.getElementById("newCommonArea");
		if (modal) {
			modal.classList.remove("hide-dinamic-modal");
			modal.classList.add("show-dinamic-modal");
		}

		// enfocar input
		const areaname = document.getElementById("areaname");
		if (areaname) {
			areaname.focus();
		}
	};



	const closeModal = () => {
		// reset de estados
		setName("");
		setDiasPrevios(0);
		setMinutosPrevios(0);
		setIsDiasDisponible(true);
		setTiempoDisponible(0);
		setDeposito(0);
		setDescripcion("");
		setAnuales(0);
		setMensuales(0);
		setDiarias(0);
		setConsecutivas(0);
		setMotivo("");
		setPausar(false);
		setMaXVivienda(1);
		setAforoMax(false);
		setActivo(false);
		setSubfraccionamientosSeleccionados([]);

		// cerrar modal por id
		const modal = document.getElementById("newCommonArea");
		if (modal) {
			modal.classList.remove("show-dinamic-modal");
			modal.classList.add("hide-dinamic-modal");
		}
	};


	// paginatorChange
	const paginatorChange = (length) => {
		setPageLength(length);
		setPage(1);
	};

	// reload
	const reload = async () => {
		await getCommonAreas();
	};

	// changeFrac
	const changeFrac = async () => {
		await getCommonAreas();
	};

	// subChange
	const subChange = (sub) => {
		setSubfraccionamiento(sub);
	};

	// setFilter
	const updateFilter = (filterValue) => {
		setFilter(filterValue.toLowerCase());
	};

	// filter
	const filterAreas = (areas) => {
		return areas.filter((com) => {
			if (com.descripcion.toLowerCase().includes(filter)) {
				return true;
			} else if (com.nombre.toLowerCase().includes(filter)) {
				return true;
			} else {
				return false;
			}
		});
	};

	// sortableTable
	const sortableTable = (key) => {
		let sd = new sortableData();
		const { items, direction: dir } = sd.sortBy(key, commonAreas, direction[key]);

		setCommonAreas(items);
		setDirection({ [key]: dir });
		setFilterColumn({ col: key, filt: dir });
	};

	// Ejemplo de función adaptada
	const handleSubmit = async (event) => {
		event.preventDefault();

		try {
			setLoadingSave(true);

			if (name === "") {
				cogoToast.warn("Es necesario añadir nombre antes de guardar.", { position: "bottom-right" });
				setLoadingSave(false);
				return;
			}

			if (aforoMax && maXVivienda > aforo) {
				cogoToast.warn("El número máximo por vivienda no puede ser mayor al número de aforo máximo.", { position: "bottom-right" });
				setLoadingSave(false);
				return;
			}

			let image = imageArea ? imageArea : "";

			// Nos aseguramos de mandar siempre un array con los checkboxes marcados.
			const seleccionados = Array.isArray(subfraccionamientosSeleccionados)
				? subfraccionamientosSeleccionados
				: [];

			const data = {
				IdFraccionamiento: parseInt(localStorage.getItem("frac")),
				// idSubfrac se manda TAL CUAL, sin cambios.
				idSubfrac: parseInt(idSubfrac),
				nombre: name,
				descripcion: descripcion !== "" ? descripcion : "Sin descripción",
				Categoria: parseInt(categoria),
				diasReserva: parseInt(diasPrevios),
				minutosPrevios: parseInt(minutosPrevios),
				Activo: activo ? 1 : 0,
				fianza: parseInt(deposito),
				diasMaximos: isDiasDisponible ? parseInt(tiempoDisponible) : null,
				horasMaximas: isDiasDisponible ? null : parseInt(tiempoDisponible),
				imagen: image,
				anuales: parseInt(anuales),
				mensuales: parseInt(mensuales),
				diarias: parseInt(diarias),
				consecutivas: parseInt(consecutivas),
				aforo: aforoMax ? parseInt(aforo) : null,
				reservasAforoMax: aforoMax ? parseInt(maXVivienda) : null,
				pausar: pausar ? 1 : 0,
				motivo: motivo,
				// Checkboxes marcados en el formulario.
				subfraccionamientosSeleccionados: seleccionados

			};



			const response = await request.post("/commonArea/create/new", data);

			if (response.created) {
				setShowModal(false);
				setImageArea("");
				setAnuales(0);
				setMensuales(0);
				setDiarias(0);
				setConsecutivas(0);

				await getCommonAreas();
				closeModal("newCommonArea");

				cogoToast.success("Área común agregada.", { position: "bottom-right" });
			} else {
				cogoToast.error("No se pudo agregar área común.", { position: "bottom-right" });
			}

			setLoadingSave(false);
		} catch (error) {
			console.log(error);
		}
	};



	// Función para mostrar preview
	const showPreviewImageCommonArea = (event) => {
		const file = event.target.files[0];
		if (file) {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onloadend = () => {
				setImageArea(reader.result);
			};
		}
	};



	const handleUpdate = (updates) => {
		if (updates.nombre !== undefined) setName(updates.nombre);
		if (updates.descripcion !== undefined) setDescripcion(updates.descripcion);
		if (updates.activo !== undefined) setActivo(updates.activo);
		if (updates.categoria !== undefined) setCategoria(updates.categoria);
		if (updates.diasPrevios !== undefined) setDiasPrevios(updates.diasPrevios);
		if (updates.minutosPrevios !== undefined) setMinutosPrevios(updates.minutosPrevios);
		if (updates.fianza !== undefined) setDeposito(updates.fianza);
		if (updates.tiempoDisponible !== undefined) setTiempoDisponible(updates.tiempoDisponible);
		if (updates.isDiasDisponible !== undefined) setIsDiasDisponible(updates.isDiasDisponible);
		if (updates.imagenArea !== undefined) setImageArea(updates.imagenArea);
		if (updates.idSubfrac !== undefined) setIdSubfrac(updates.idSubfrac);
		// Los checkboxes actualizan su propia variable, no idSubfrac.
		if (updates.subfraccionamientosSeleccionados !== undefined) setSubfraccionamientosSeleccionados(updates.subfraccionamientosSeleccionados);
		if (updates.anuales !== undefined) setAnuales(updates.anuales);
		if (updates.mensuales !== undefined) setMensuales(updates.mensuales);
		if (updates.diarias !== undefined) setDiarias(updates.diarias);
		if (updates.consecutivas !== undefined) setConsecutivas(updates.consecutivas);
		if (updates.aforo !== undefined) setAforo(updates.aforo);
		if (updates.aforoMax !== undefined) setAforoMax(updates.aforoMax);
		if (updates.maXVivienda !== undefined) setMaXVivienda(updates.maXVivienda);
		if (updates.pausar !== undefined) setPausar(updates.pausar);
		if (updates.motivo !== undefined) setMotivo(updates.motivo);
	};

	return (
		<div className="admin column">
			<Helmet>
				<title>{process.env.REACT_APP_NAME} - {submenu}</title>
			</Helmet>

			<Header
				reload={reload}
				change={changeFrac}
				sidebar={true}
				active="activas"
				parent="areas"
				panel="panel3"
				nav="operacion"
				menu={menu}
			/>

			<div className="row">
				<div className="column" id="sidebar">
					<SidebarOperacion />
				</div>
				<div className="column" id="content">
					<div className="justify-center">
						<div className="container column">
							{lectura && (
								<>
									<Controls
										title={submenu}
										nuevo={openModal}
										dataSet={filterAreas(commonAreas)}
										setFilter={updateFilter}
										subChange={subChange}
										newButton={escritura}
										limitCategorias={true}
										onLimitCategorias={handleOpenCategoryModal}
									/>

									{loading ? (
										<div className="row justify-center">
											<i className="fas fa-spinner fa-spin"></i>
										</div>
									) : (

										<CommonAreaTable
											commonAreas={filterAreas(commonAreas)}
											subfraccionamientos={subfraccionamientos}
											page={page}
											reload={reload}
											escritura={escritura}
											pageLength={pageLength}
											sortBy={sortableTable}
											filterColumn={filterColumn}
											subLabel={subLabel}
											getCommonAreas={getCommonAreas}
										/>

									)}

									<div className="white-space-16"></div>

									<Paginador
										pages={Math.ceil(filterAreas(commonAreas).length / pageLength)}
										setPage={setPage}
										pageLength={pageLength}
										paginatorChange={paginatorChange}
										showPageLenght={true}
									/>
								</>
							)}
						</div>
					</div>
				</div>
			</div>

			<DinamicModal
				idModal="newCommonArea"
				sizeModalContainer="big"
				title="Añadir área común"
				success={handleSubmit}
				showBtnSuccess={true}
				btnTextSuccess="GUARDAR"
				showBtnCancel={true}
				btnTextCancel="CANCELAR"
				loadingSave={loadingSave}
				message={message}
				closeModal={closeModal}
				showModal={showModal}
			>
				<CommonAreasCreate
					state={state}
					handleUpdate={handleUpdate}
					showPreviewImageCommon={showPreviewImageCommonArea}
					onSubmit={handleSubmit}
				/>
			</DinamicModal>

			<BloqcatModal
				isOpen={showUpdateCategoryModal}
				onClose={handleCloseModal}
				onUpdateCategorySuccess={handleUpdateCategorySuccess}
			/>
		</div>
	);



};

export default CommonAreas;